import { getTitle } from "../../../../helpers/admin/productHelper";

import {
    Grid, Typography, Card, CardContent, CardMedia,
    IconButton
} from "@mui/material";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { PROMO_PRODUCT } from "../../../../constants/shop/promotion/promotion_const";

const ProductItem = ({ product, setProduct, alt, text }) => {
    const { title, variant_title, price, image_id } = product;
    
    return (
        <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
            <Card sx={{
                position: "relative", width: '100%', height: "100%",
                display: "flex", flexDirection: "column"
            }}>
                <IconButton size="large"
                    sx={{
                        position: "absolute",
                        top: 8, right: 8, zIndex: 2,
                        color: "primary.main"
                    }}
                    onClick={ () => setProduct(PROMO_PRODUCT) }
                >
                    <RemoveCircleOutlineIcon fontSize="inherit" />
                </IconButton>
                
                <CardMedia
                    sx={{ height: 200, backgroundSize: 'contain' }}
                    image={image_id}
                    alt={alt}
                />
                <CardContent sx={{
                    flexGrow: 1, display: "flex", flexDirection: "column",
                    justifyContent: "flex-end"
                }}>
                    <Typography variant="h6">
                        { getTitle(title, variant_title) }
                    </Typography>
                    <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                        { `$${price}` }
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: "auto" }}>
                        { text }
                    </Typography>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default ProductItem;
